export const enumKeysToArray = <T extends Record<string, string | number>>(enumObj: T): Array<keyof T> => {
  return Object.keys(enumObj)
    .filter((key) => Number.isNaN(Number(key)))
    .map((key) => key as keyof T);
};
